import type { AiWidget } from "@repo/shared/types";
import { CallWidget } from "./call-widget";
import { ClientFileWidget } from "./client-file-widget";
import { ClientListWidget } from "./client-list-widget";
import { FlowInstanceWidget } from "./flow-instance-widget";
import { MeetingWidget } from "./meeting-widget";
import { NoteWidget } from "./note-widget";
import { PieChartWidget } from "./pie-chart-widget";
import { SourceListWidget } from "./source-list-widget";
import { TableWidget } from "./table-widget";

interface WidgetProps {
  widget: AiWidget;
  chartColors?: string[] | null;
  onClientClick?: (clientId: string) => void;
  onSourceClick?: (source: { pageId: string; title: string; slug: string }) => void;
  onFlowInstanceClick?: (url: string) => void;
  onActivityClick?: (url: string) => void;
}

export function Widget({
  widget,
  chartColors,
  onClientClick,
  onSourceClick,
  onFlowInstanceClick,
  onActivityClick,
}: WidgetProps) {
  switch (widget.type) {
    case "client_list":
      return <ClientListWidget clients={widget.clients} onClientClick={onClientClick} />;
    case "source_list":
      return <SourceListWidget sources={widget.sources} onSourceClick={onSourceClick} />;
    case "pie_chart":
      return <PieChartWidget title={widget.title} data={widget.data} chartColors={chartColors} />;
    case "flow_instance":
      return <FlowInstanceWidget instance={widget} onFlowInstanceClick={onFlowInstanceClick} />;
    case "note":
      return <NoteWidget note={widget} onActivityClick={onActivityClick} />;
    case "call":
      return <CallWidget call={widget} onActivityClick={onActivityClick} />;
    case "meeting":
      return <MeetingWidget meeting={widget} onActivityClick={onActivityClick} />;
    case "client_file":
      return <ClientFileWidget file={widget} />;
    case "table":
      return <TableWidget table={widget} />;
    default:
      return null;
  }
}
